<template>
  <div class="page-content">
    <div class="page-box">
      <div class="page-box-content">
        <Row type="flex" justify="space-between">
          <Col>
            <i-form inline>
              <FormItem>
                <Input v-model="where.name" :placeholder="$t('name.address.name')" style="width: 120px" />
              </FormItem>
              <FormItem>
                <Input v-model="where.phone" :placeholder="$t('name.address.phone')" style="width: 120px" />
              </FormItem>
              <FormItem>
                <Button type="primary" icon="md-search" @click="search">{{ $t('name.search') }}</Button>
              </FormItem>
            </i-form>
          </Col>
        </Row>
        <Table ref="table" :list="list" @get="getData" />
        <div class="page-box-content" style="text-align:center">
          <Page 
            :current.sync="where.page" 
            :total="total" 
            :page-size="size" 
            @on-change="getData" 
            show-total 
            show-elevator 
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Table from './table'
import { get } from '@/api/address';

export default {
  components:{
    Table
  },
  data() {
    return {
      list: [],
      total: 0,
      size: 0,
      where: {
        page: 1,
        name: null,
        phone: null
      }
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      get(this.where).then(res => {
        this.list = res.data
        this.where.page = res.current_page
        this.total = res.total
        this.size = res.per_page
      })
    },

    // 搜索
    search() {
      this.where.page = 1
      this.getData()
    }
  },
};
</script>